"use strict";

Object.defineProperty(exports, "__esModule", {
        value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SolidYellowWarning = function SolidYellowWarning() {
        return _react2.default.createElement(
                "g",
                { id: "SolidYellowWarning", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                _react2.default.createElement("image", { id: "key_under", x: "0", y: "0", width: "500", height: "500", xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAcCAYAAAB2+A+pAAAABGdBTUEAALGPC/xhBQAAA55JREFUSA2tVj1Mk1EUbUvBKAIWLWjbNCZORk1MmEgIaEIcjAxsshh07GCc3IyDnUwkDpgwGB10YiOwsBAaZdKQEkkkWqEFsdpIsRT73z7Pqd/tH/2Hmxy+++67755733v3FZ2uedFjKdGUNLJQfMsRKo2dX9GrJmSoOpufFDL6twCtPp+vf3t7+7rNZmvD2AiIjyQI0+FFCI8h1MlQKPRMaQL9BW0A55hAvcXAtbqwAlbJwB2zs7MD4EwJMfWZmZlBzHVqPvQ9kqpZQSvQDvTs7e0tFpBmVdjeYa4XYOX0PXTVUu1xBOteWFi4U0oqY5fLdQ8+pwH6HrpqZs7L02mxWOyRSOSLEJV+o9Ho+nkIfbU1TVfNanlZTgBmt9v9qJSsdLy6uvqEvtoauekY1i8klWq7RkdHLyaTyd+FRGH/nNr1vlbpRDBnhk9ofHz8CtZ2AbyMjMFYdQsXMGNeqN6NjY2pXHRN8bsfqPXFIZWMfC+a2traesM12tqK7VXuHJghwQvS5nQ6L9jt9rvQi8Rg5AnA0ci7lBer1Xp7cnLyMiylD0veqYLGZNgSbI2zgUBgrqgkbRD47MxWnEnHDkwHg0EX1p7TYpRtr9KKi6qdnp7uN5vNNxHggBha2nV6fYtOb+BRFovJZBqcn5+/ASsnpbUYu6JItR3wsITD4eUD5WiG4PqU8r2/VWlaofW+sgURp2Z7MSNmx0M7s7S0dL9iVEyk4jsqsf+tmotaWVl5jFg124vVZh+Lvr6+C7FYrPi6llD88b1VP5YdKpOOlszkh2iv4NjY2CXEZXsxNjmKtpwDeSx61tbWnuaXl9d+fnqoNlzXVCr2q7yDZt3c3HyF2BXbS6rtcjgcV1OpVLhqNEymkyEV3/fUclOZTCYxMTExBPJTgDwqUPM9y7M1ezye5zWjNejg9XpfInYPwObPPqWslCIXy4hz4QU7UonH4/x3SF6x3BlTYZOzhazDw8MDfr//I7ao8Me+wRr/uyNGBrE+jIyMcKttAFsr+6CQlGA23H+SdwP8XTUBfL14GxvdhTTWJIC/wC6wAwSBMBAD0iSkcCsyQBKIAnSgUC/75GVnK/9hrBQgsSLQGZsJkUsVEtMYB5glFzIzqTZ3LrDVIwwuVTMOiRlbiHPNzEtGcEtZIQmZFCEXEGpDwuRJxEq57dwBgvaMVCJnzS/JJZFCO8x1S3Y74S1HKEnk7ELMiKILWaGNejNCIooQiq77B8NtkmBiKyB4AAAAAElFTkSuQmCC" })
        );
};

exports.default = SolidYellowWarning;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/SolidYellowWarning.js
// module id = 2989
// module chunks = 4